import * as React from "react";

export const IconOpenInNew = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13.3333 13.3333L1.66667 13.3333L1.66667 1.66667L7.5 1.66667V0L1.66667 0C0.741667 0 0 0.75 0 1.66667L0 13.3333C0 14.25 0.741667 15 1.66667 15L13.3333 15C14.25 15 15 14.25 15 13.3333V7.5L13.3333 7.5V13.3333ZM9.16667 0V1.66667L12.1583 1.66667L3.96667 9.85833L5.14167 11.0333L13.3333 2.84167L13.3333 5.83333L15 5.83333L15 0L9.16667 0Z"
      fill={props?.color ?? "#767B7E"}
    />
  </svg>
);
